import Info from "./Info"
import Settings from "./Settings"
import Rules from "./Rules"

export { Info, Settings, Rules }
